import { Dispatch, PropsWithChildren, SetStateAction, createContext, useState } from 'react'

import { HeaderProps } from '@components/Header/Header.props'

export const HeaderContext = createContext<HeaderProps | null>(null)
export const HeaderSetterContext = createContext<Dispatch<SetStateAction<HeaderProps | null>>>(() => null)

export function HeaderContextProvider({ children }: PropsWithChildren) {
  const [header, setHeader] = useState<HeaderProps | null>(null)

  return (
    <HeaderContext.Provider value={header}>
      <HeaderSetterContext.Provider value={setHeader}>{children}</HeaderSetterContext.Provider>
    </HeaderContext.Provider>
  )
}
